import { CustomHttpClient } from '../../providers/CustomHttpClient';
import { Injectable } from '@angular/core';
import { UserDetails } from '../../model/userDetails'


@Injectable({
  providedIn: 'root'
})
export class InductionService {

  constructor(private http: CustomHttpClient) {}

  onSearchConfiguration(user: UserDetails) {
    return this.http.Get(`api/cupom/GetConfiguration/${user.param_is_pln}`);
  }

}
